import * as React from "react";
import { Input, Col, Form, Checkbox, Row } from "antd";

import { FormInstance } from "antd/lib/form";
import { IOrganisation } from "../../../organisations/model/Organisation";
import SelectInput from "../../../core/ui/components/SelectInput";
import { IRegistryInstitution } from "../../model/RegistryInstitution";

const FormFields = {
  ID: "id",
  NAME: "name",
  INSTITUTION_ID: "hrmsInstitutionCode",
  VALID: "valid"
};

const OrganisationForm = ({
  translate,
  form,
  rowData,
  institutions
}: {
  translate: any;
  form: FormInstance;
  rowData?: IOrganisation;
  institutions: IRegistryInstitution[];
}) => {
  return (
    <Form layout={"vertical"} form={form}>
      <Form.Item
        name={FormFields.ID}
        initialValue={rowData?.id}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Row gutter={16} className={"content-section-modal-emphasize"}>
        <Col lg={22} sm={21} xs={20}>
          <Form.Item
            label={translate("editors.organisations.institution")}
            className={"mb-0"}
            name={FormFields.INSTITUTION_ID}
            initialValue={rowData?.hrmsInstitutionCode}
            rules={[
              {
                required: true,
                message: translate("editors.organisations.required_messages", {
                  field: translate("editors.organisations.organisation_name")
                })
              }
            ]}
          >
            <SelectInput
              placeholder={translate(
                "editors.organisations.select_institution"
              )}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"code"}
              selectOptionValue={"name"}
              selectOptions={institutions}
            />
          </Form.Item>
        </Col>
        <Col
          lg={2}
          sm={3}
          xs={4}
          style={{
            display: "flex",
            marginTop: 20,
            alignItems: "center"
          }}
        >
          <Form.Item
            label={translate("editors.organisations.valid")}
            className={"png-form-item-horizontal-checkbox mb-0"}
            name={FormFields.VALID}
            valuePropName={"checked"}
            initialValue={rowData?.valid ?? true}
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className={"content-section-modal-borderless pb-0"}>
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.organisations.name")}
            className={"mb-0"}
            name={FormFields.NAME}
            initialValue={rowData?.name}
            rules={[
              {
                required: true,
                message: translate("editors.organisations.required_messages", {
                  field: translate("editors.organisations.name")
                })
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default OrganisationForm;
